// Centralized API utility for all fetch calls
// Usage: import { apiFetch } from './api';

export function apiFetch(endpoint, options = {}) {
  const baseUrl = process.env.REACT_APP_API_URL || '';
  // Ensure no double slashes
  const url = baseUrl.replace(/\/$/, '') + (endpoint.startsWith('/') ? endpoint : '/' + endpoint);
    return fetch(url, {
    credentials: 'include',   // 🔑 THIS FIXES MOBILE
    ...options,
  });
}
